export default {
  isProfitViewActive(state) {
    return state.profitView;
  },
  getTime(state) {
    return state.timer;
  },
  getCurrency(state) {
    return state.selectedCurrency;
  },
  getCurrencyRate(state) {
    return state.currencyRate[state.selectedCurrency];
  },

  getCurrencySymbol(state) {
    return state.currencySymbol[state.selectedCurrency];
  },
  getTimeUnits(state) {
    return state.timeUnits;
  },
  getGameProfitFactor(state){
    const currencyRate = state.currencyRate[state.selectedCurrency];
    const timeConversion = state.timeConversion[state.timeUnits];
    return Math.floor(state.timer * timeConversion * currencyRate);
  },
  getSortCat(state) {
    return state.sortCategory;
  },
  getSortDirection(state){
    return state.sortDirection;
  }
};
